var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRespectedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 23V14.775L3 9.5L7.625 2H16.875L21.5 9.5L18.25 14.775V23L12.25 21L6.25 23ZM8.25 20.225L12.25 18.9L16.25 20.225V17H8.25V20.225ZM8.75 4L5.35 9.5L8.75 15H15.75L19.15 9.5L15.75 4H8.75ZM11.2 13.575L7.65 10.05L9.075 8.625L11.2 10.75L15.425 6.5L16.85 7.9L11.2 13.575Z",
    fill: "url(#paint0_linear_11757_124034)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11757_124034",
    x1: 3.82724,
    y1: 12.5,
    x2: 21.5,
    y2: 12.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.145,
    stopColor: "#204A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#459F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#459F49"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRespectedIcon);
export default __webpack_public_path__ + "static/media/respected-icon.17a31cbe3d3899c4aa2684301fa6f142.svg";
export { ForwardRef as ReactComponent };